import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import { BehaviorSubject, Observable } from 'rxjs';

import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import * as backInter from 'app/auth/auth-data.model';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'traducciones',
  templateUrl: './traducciones.component.html',
  styleUrls: ['./traducciones.component.scss']
})
export class TraduccionesComponent implements OnInit {

  // firstFormGroup: FormGroup;
  // secondFormGroup: FormGroup;
  banderaEncuestaFocus: backInter.actualizaBanderaFocus;
  bloqueaSeccionAdicionales:boolean;
  @Input('productoCertificar') productoFocus: backInter.prodFocusArea;
  @Input('idiomas') idiomas: backInter.getIdiomas;
  @Input('preguntasAdicionales') preguntasAdicionales: backInter.getPreguntasAdiocnalesFocus;
  @Input('preguntasTraduccionesAdicionalesFocus') preguntasTraduccionesAdicionalesFocus: backInter.respuestaTraduccionesPreguntasAdicionalesFocus;

  private eventsSubscription: any
  @Input() actualizaAdicionales: Observable<any>;

  @Output() actualizarAdicionales: EventEmitter<boolean> = new EventEmitter();

  idiomaDefault: backInter.getIdiomaInd;
  idiomasAdicionales: backInter.getIdiomaInd[] = [];

  textosPreguntasFiltrados: any[] = [];
  nombreIdiomaAdicional: any[] = [];
  textosPreguntasRestoIdiomas: any[] = [];

  formGroups: FormGroup[] = [];

  totalTextosTraduccion = 0;
  numeroTextosTraduccion: number[] = [];

  idsTraduccionesBD: any[] = [];
  idsTraduccionesOpcionesBD: any[] = [];

  //etiquetas para encontrar los textos de traduccion
  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_MOD_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_MOD_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_NOPREG',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_MOD_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_MOD_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.VALOR_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.VALOR_MOD_OK',
  ]
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    preg_ok: '',
    preg_err: '',
    preg_mod_ok: '',
    preg_mod_err: '',
    opc_nopreg: '',
    opc_ok: '',
    opc_err: '',
    opc_mod_ok: '',
    opc_mod_err: '',
    valor_ok: '',
    valor_mod_ok: '',
  };

  //tipos de pregunta
  idAbierta = 2;
  idSingle = 1;
  idMulti = 6;

  constructor(
    private _formBuilder: FormBuilder,
    private adicionalesService: AdicionalesService,
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    console.log("estos son los idiomas de focu ",this.idiomas);
    this.eventsSubscription = this.actualizaAdicionales.subscribe( (datos) => {
      console.log("actualiza lista adicionales en traducciones");
      this.reiniciaVariables();
      // this.preguntasAdicionales = datos;
      this.preguntasTraduccionesAdicionalesFocus = datos;
      console.log(datos);

      this.obtieneIdiomas();
    })
    this.getActualizaBanderaEvaluarEncuesta();
    setTimeout( () => {
      this.obtieneIdiomas();
      this.traduceTextosTS();
      // console.log(this.preguntasAdicionales);
    },2000);
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
  }

  reiniciaVariables(){
    this.idiomaDefault = null;
    this.idiomasAdicionales = [];
    this.textosPreguntasFiltrados = [];
    this.nombreIdiomaAdicional = [];
    this.textosPreguntasRestoIdiomas = [];
    this.formGroups = [];
    this.totalTextosTraduccion = 0;
    this.numeroTextosTraduccion = [];
    this.idsTraduccionesBD = [];
  }

  obtieneIdiomas(){
    console.log(this.idiomas);
    if(this.idiomas.idiomas.length > 0){

      console.log("tamaño idiomas");
      // console.log(this.idiomas.idiamas.length);
      this.idiomas.idiomas.forEach( (idioma: backInter.getIdiomaInd) => {
        if(idioma.tipoIdioma == "1"){
          this.idiomaDefault = idioma;
        }
        else if(idioma.tipoIdioma == "0"){
          this.idiomasAdicionales.push(idioma);
          console.log(this.idiomasAdicionales);

        }
      });
      console.log(this.idiomaDefault);
      this.filtraTextosIdiomaPrincipalFocus();
      this.creaFormGroups();
    }
  }

  creaFormGroups(){
    // console.log(this.numeroTextosTraduccion);
    for(let i=0;i<this.idiomasAdicionales.length;i++){
      // this.formGroups.push(new FormGroup({}) );
      let group = {};

      let iterador = 0;
      this.numeroTextosTraduccion.forEach( (objeto) => {

        group["texto"+iterador] = new FormControl('');
        console.log("objeto es igual ",objeto);

        if(objeto > 1){
          for(let x=0;x<objeto-1;x++){
            // console.log("texto"+iterador+"Opc"+x);
            group["texto"+iterador+"Opc"+x] = new FormControl('');

          }
        }

        iterador++;
      });

      // for(let j=1;j<=5;j++){
      //   group['control'+j] = new FormControl('');
      // }
      this.formGroups.push(new FormGroup(group) );
    }
    console.log(this.formGroups);

  }

  filtraTextosIdiomaPrincipalFocus(){
    console.log(this.preguntasTraduccionesAdicionalesFocus);
    let numeroOpcionAdicional=0;
    this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.forEach( (adicional) => {
    let preguntas: any[]=[];
      adicional.preguntas.forEach( (textos) => {
        let numeroTextos=0;
        numeroTextos++;
        console.log(textos);
        if(textos.tipoRespuesta!=3){
          let  objetoTextoAdicional = {
            textoPregunta : textos.pregunta,
            tipoPregunta : textos.tipoAgregado,
            opcionesResp : textos.opciones,
            orden: textos.orden,
            tipoRespuesta: textos.tipoRespuesta,
            seccion: textos.seccion,
            requerido: textos.requerido,
            _id: textos._id,
            traduccion: textos.traduccion

          };
        preguntas.push(objetoTextoAdicional);
        numeroTextos+= textos.opciones.length;
        console.log(numeroTextos);
}else{
console.log("es de tipo 3 ");

}

        this.numeroTextosTraduccion.push(numeroTextos);

    });
      this.textosPreguntasFiltrados.push(
      {
        clave:   adicional.clave,
        idiomaId: adicional.idiomaId,
        preguntas: preguntas,
      });
        numeroOpcionAdicional++;
      console.log("textosPregFilt:",this.textosPreguntasFiltrados);
    });
  }

  guardaTraduccion(event:any, datos:any, idIdioma:string, identificador?:string, idAdicional?:string){
    if(event.target.value.length > 0){
      if(idAdicional && datos.traduccion !=""){
        this.modificaTraduccionBD(event, datos, idAdicional, idIdioma );
        console.log("entro modificar pregunta");
      }
      else{
          //guarda la nueva traduccion
          console.log("traduccion nueva ");
        this.guardaTraduccionBD(event, datos, idIdioma, identificador);

      }
    }
  }

  guardaTraduccionBD(event:any, datos:any, idIdioma:string, identificador:string){
    let traduccion = {} as backInter.nuevoAdicionalFocus;
    console.log(datos);
    traduccion.preguntaId = datos._id;
    traduccion.pregunta = event.target.value;
    traduccion.idiomaId = idIdioma;
    traduccion.empresaId = localStorage.getItem('companyID');
    // traduccion.orden = datos.orden;

    console.log("identificador:"+identificador);
    console.log("traduccion a guardar:");
    console.log(traduccion);
this.modalCargaGuardaTraduccionPregunta();
    this.adicionalesService.guardaTraduccionAdicionalFocus(traduccion).subscribe( (data: any) => {
      console.log(data);
      if(data.success){
        Swal.close();
        this.idsTraduccionesBD.push({idTraduccion:data.traduccionMostrar._id, identificador:identificador, idIdioma:idIdioma});
        this.openSnackBar(this.mensajesTraducirTS.preg_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else this.openSnackBar(this.mensajesTraducirTS.preg_err, "OK");
    });
  }

  modificaTraduccionBD(event:any, datos:any, idTraduccion:string, idIdioma: string){
    let traduccion:any={
      empresaId: localStorage.getItem('companyID'),
      preguntaId: idTraduccion,
      pregunta:event.target.value,
      idiomaId: idIdioma

    }

    this.modalCargaActualizaTraduccionPregunta();

    this.adicionalesService.actualizaAdicionalTraduccionesFocus(traduccion).subscribe( (data:any) => {
      if(data.success){
        Swal.close();
        this.openSnackBar(this.mensajesTraducirTS.preg_mod_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else this.openSnackBar(this.mensajesTraducirTS.preg_mod_err, "OK");
      // console.log(data);
    });
  }


  guardaTraduccionOpcion(event:any, datos:any, idIdioma:string, idPreg:number, idOpc:number, datosOpc:any, idAdicional?:string){
    console.log("se actualizara una opcion. datos: ", datosOpc);
    if(event.target.value.length > 0){
     if(idAdicional && datosOpc.traduccion !=""){
        this.actualizaTraduccionOpcionBD(event,datos, idIdioma, idPreg, idOpc, datosOpc,idAdicional);
        console.log("idAdicional");
      }
      else{
          //guarda la nueva traduccion
          console.log("qui esta+");
          this.guardaTraduccionOpcionBD(event,datos, idIdioma, idPreg, idOpc, datosOpc,idAdicional);

      }


}

  }


  guardaTraduccionOpcionBD(event:any, datos:any, idIdioma:string, idPreg:number, idOpc:number, datosOpc:any, idAdicional?:string){
    let datosTradu: any = {
        "empresaId": localStorage.getItem('companyID'),
        "preguntaId": idAdicional,
        "respuesta": event.target.value,
        "orden": idOpc,
        "idiomaId": idIdioma
      };
      this.modalCargaGuardaTraduccionOpcion();
  this.adicionalesService.guardaTraduccionOpcionesAdicionalFocus(datosTradu).subscribe( (data: any) => {
    console.log(data);

      if(data.success){
        Swal.close();
        // this.enviaMensajeSnack(9);
        // console.log("se actualizo la opcion");
        this.openSnackBar(this.mensajesTraducirTS.opc_mod_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else
      this.openSnackBar(this.mensajesTraducirTS.opc_mod_err, "OK");
    });
  }

  actualizaTraduccionOpcionBD(event:any, datos:any, idIdioma:string, idPreg:number, idOpc:number, datosOpc:any, idAdicional?:string){
    let datosTradu: any = {
        "empresaId": localStorage.getItem('companyID'),
        "preguntaId": idAdicional,
        "respuesta": event.target.value,
        "orden": idOpc,
        "idiomaId": idIdioma
      };


    console.log("se actualizara una opcion. datos:");
    // console.log(opcion);
    this.modalCargaActualizaTraduccionOpcion();
    this.adicionalesService.actualizaAdicionalTraduccionesFocus(datosTradu)
    .subscribe( (data: any) => {
      if(data.success){
        Swal.close();
        this.openSnackBar(this.mensajesTraducirTS.opc_mod_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else
      this.openSnackBar(this.mensajesTraducirTS.opc_mod_err, "OK");
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 1000,
    });
  }

  getActualizaBanderaEvaluarEncuesta(){
    let datos={productoId:localStorage.getItem('productoID')};
    this.adicionalesService.getActulizaBanderaEncuestaFocus(datos).subscribe( (data: backInter.actualizaBanderaFocus) => {
      console.log(data);


      this.banderaEncuestaFocus=data;
      if (this.banderaEncuestaFocus.estatusVerificacion==2 || this.banderaEncuestaFocus.estatusVerificacion==5) {
        this.bloqueaSeccionAdicionales=true;
        console.log(this.bloqueaSeccionAdicionales);

      }else{
        this.bloqueaSeccionAdicionales=false;
        console.log(this.bloqueaSeccionAdicionales);
      }


      });
  }



  modalCargaGuardaTraduccionPregunta(){
    let mensaje:string;
    this.translateSrv.get('CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.TRADUC_PREGUNT').subscribe((res: string) => { mensaje = res; });

    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,

      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  modalCargaActualizaTraduccionPregunta(){
    let mensaje:string;
    this.translateSrv.get('CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.TRADUC_MOD_PREGUNT').subscribe((res: string) => { mensaje = res; });

    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,

      didOpen: () => {
        Swal.showLoading()
      }
    });
  }


  modalCargaGuardaTraduccionOpcion(){
    let mensaje: string;
    this.translateSrv.get('CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.TRADUC_OPC').subscribe((res: string) => { mensaje = res; });

    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,

      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  modalCargaActualizaTraduccionOpcion(){
    let mensaje: string;
    this.translateSrv.get('CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.TRADUC_MOD_OPC').subscribe((res: string) => { mensaje = res; });

    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,

      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

}
